import AppLoadingIndicator from 'components/common/AppLoadingIndicator';
import config from 'config';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

const Redirect = (): JSX.Element => {
  const [searchParams] = useSearchParams();
  const { i18n, t } = useTranslation('component');
  const redirect_uri = searchParams.get('redirect_uri');
  const url = (
    redirect_uri != null && redirect_uri.length > 0
      ? decodeURIComponent(redirect_uri)
      : config.REGISTER_CONFIRMATION_REDIRECT
  ).replace('{lang}', i18n.resolvedLanguage);
  window.location.href = url;
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>{t('MetaTag.RedirectTitle')}</title>
        <meta name="description" content={t('MetaTag.RedirectDescription').toString()} />
      </Helmet>
      <AppLoadingIndicator />
    </>
  );
};

export default Redirect;
